import Url from 'url';

const UrlParam = {
  /**
   * 获取url链接上的所有参数
   * @param {*} url
   * @returns {Object} {key: value}
   */
  getUrlQuery(url:string) {
    const theRequest: any = {};
    if (url && url.indexOf('?') !== -1) {
      const str = url.substr(1);
      const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
      }
    }
    return theRequest;
  },

  /**
   * 获取url获取第一层路由中的参数
   * @param {*} url
   * @returns
   */
  parseUrlQueryString(url:string) {
    let arr;
    const res: any = {};
    // #符号之后的值称为hash，都不会加到request请求中去
    url = url.split('#')[0];
    // 获取queryString 第一个？号后面的全是查询字符串
    arr = url.split('?');
    arr.shift();
    const queryStr = arr.join('?');
    // 查询字符串为空直接返回 避免出现这样的返回值{"":""}
    if (queryStr.trim().length === 0) {
      return res;
    }

    // 获取参数
    arr = queryStr.split('&');
    for (let i = 0; i < arr.length; i++) {
      const itemArr = arr[i].split('=');
      // 第一个=号之前的是name 后面的全是值
      const name: any = itemArr.shift();
      const value = itemArr.join('=');
      res[name] = decodeURIComponent(value);
    }
    return res;
  },

  /**
   *  获取url中的某个参数值
   *  @param url
   *  @param key
   */
  getUrlParamVal(url = '', key: any) {
    const paramsObj: any= {};
    const paramsArr = url.substring(url.indexOf('?') + 1, url.length).split('&');
    for (let i = 0, len = paramsArr.length; i < len; i++) {
      const param = paramsArr[i];
      const flagArr = param.split('=');
      paramsObj[flagArr[0]] = flagArr[1];
    }

    return paramsObj[key] || '';
  },

  /**
   * url中添加一个参数
   * @param url
   * @param param
   * @param value
   * @returns {string}
   */
  addUrlParam(url: string, param: any, value: any) {
    const loca: any = Url.parse(url, true);
    const baseUrl = loca.protocol + '//' + loca.hostname + loca.pathname;
    const query = loca.search.substring(1);
    const p = new RegExp('(^|&)' + param + '=(.*?)(?=&|$)');
    if (p.test(query)) {
      const newQuery = query.replace(p, '$1' + param + '=' + value);
      return baseUrl + '?' + newQuery;
    } else {
      if (query === '') {
        return baseUrl + '?' + param + '=' + value;
      } else {
        return baseUrl + '?' + query + '&' + param + '=' + value;
      }
    }
  },

  /**
   * url中删除一个参数
   * @param url
   * @param param
   * @returns {string}
   */
  delUrlParam(url: string, param: any) {
    const loca: any = Url.parse(url, true);
    const baseUrl = loca.protocol + '//' + loca.hostname + loca.pathname;
    const query = loca.search.substring(1);
    const p = new RegExp('(^|&)' + param + '=(.*?)(?=&|$)');
    if (p.test(query)) {
      let newQuery = query.replace(p, '');
      if (newQuery.startsWith('&')) {
        newQuery = newQuery.substring(1);
      }
      return baseUrl + '?' + newQuery;
    } else {
      if (query === '') {
        return baseUrl;
      } else {
        return baseUrl + '?' + query;
      }
    }
  },

  /**
   * 替换url中某个参数值
   * @param url
   * @param paramName
   * @param replaceWith
   */
  replaceUrlParamVal(url: string, paramName: any, replaceWith: any) {
    try {
      // eslint-disable-next-line no-eval
      const re = eval('/(' + paramName + '=)([^&]*)/gi');
      const nUrl = url.replace(re, paramName + '=' + replaceWith);
      return nUrl;
    } catch (e) {
      return url;
    }
  },

  /**
   * 为url拼接type以及data
   * @param {*} url
   * @param {*} data
   * @param {*} type
   * @returns {String}
   */
  recommendLogUrl(url: string, data: any, type = 2) {
    if (!data || typeof data !== 'object') {
      return url;
    }
    if (type) {
      url = url ? url + `&type=${type}` : `type=${type}`;
    }
    Object.keys(data).forEach((key) => {
      url += `&${key}=${data[key]}`;
    });
    return url;
  }
};

export default UrlParam;
